"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.isReactFragment = isReactFragment;
var _react = _interopRequireDefault(require("react"));
function isReactFragment(variableToInspect) {
  if (!variableToInspect) return false;
  if (variableToInspect.type) {
    return variableToInspect.type === _react.default.Fragment;
  }
  return variableToInspect === _react.default.Fragment;
}
var _default = exports.default = isReactFragment;